import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { WbsIcon } from "./wbsIcon";
import { KanbanIcon } from "./kanbanIcon";
import styles from "./styles.scss";

function ToggleButton({ isActive, toggle }: Props) {
  const { t } = useTranslation();

  return (
    <div onClick={toggle} className={styles.toggleButton}>
      <div className={classNames(styles.thumb, { [styles.right]: isActive })} />
      <div className={classNames(styles.row, { [styles.selected]: !isActive })}>
        <p className={styles.label}>{t("projectPage.listsPage.toggle.wbs")}</p>
        <WbsIcon className={styles.icon} />
      </div>
      <div className={classNames(styles.row, { [styles.selected]: isActive })}>
        <p className={styles.label}>
          {t("projectPage.listsPage.toggle.statuses")}
        </p>
        <KanbanIcon className={styles.icon} />
      </div>
    </div>
  );
}

export { ToggleButton };
